import {Field, useField} from "formik";
import {Select} from "formik-material-ui";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import {default as React, memo} from "react";
import {DropdownSelectProps, DropdownSelectValue} from "./dropdown-select.interface";

const isEmptySelection = (selected: any): boolean =>
    Array.isArray(selected) ? selected.length === 0 : selected === '' || selected === null || selected === undefined;

const selectedNames = (values: DropdownSelectValue[], selected: any): string => {
    const selection = Array.isArray(selected) ? selected : [selected];

    return values
        .filter(value => selection.some(item => String(item) === String(value.value)))
        .map(value => value.name)
        .join(', ');
};

//  TODO: Move to common package
export const DropdownSelect = memo((props: DropdownSelectProps) => {
    const [, meta] = useField(props.inputPropName);

    //  Same condition as formik-material-ui uses for TextField,
    //  so a dropdown reports a validation error like any other form control.
    const showError = !!meta.touched && !!meta.error;

    const inputProps = {
        id: props.inputPropName,
        name: props.inputPropName,
    };

    //  Material-UI Select ignores the native 'placeholder' attribute,
    //  so an empty selection has to be rendered explicitly.
    const renderValue = props.placeholder
        ? (selected: any) => isEmptySelection(selected)
            ? <span style={{opacity: 0.42}}>{props.placeholder}</span>
            : selectedNames(props.values, selected)
        : undefined;

    return (
        <FormControl error={showError} fullWidth={true}>
            <Field
                component={Select}
                className={props.inputStyle}
                name={props.inputPropName}
                value={props.selectedValues}
                multiple={props.multiple}
                disabled={props.disabled}
                inputProps={inputProps}
                displayEmpty={!!props.placeholder}
                renderValue={renderValue}
            >
                {props.values.map(value => (<MenuItem key={value.value} value={value.value}>
                    {value.name}
                </MenuItem>))}
            </Field>

            {showError && <FormHelperText>{meta.error}</FormHelperText>}
        </FormControl>
    );
});
